import { an } from 'vitest/dist/types-198fd1d9';

/** @description response de invitar amigo */
export type ResponseInvitarAmigo = {
  estado: true;
  /**
   * @description si enviado=true =>  'El email fue enviado'
   * @example El email fue enviado
   */
  mensaje?: string;
  /** @description obvio. true o undefined */
  enviado?: boolean;
};

export type RequestParamsInvitarAmigo = {
  /** @description nombre del usuario invitado */
  nombreUsuarioInvitado: string;

  /** @description email del usuario invitado */
  emailUsuarioInvitado: string;
};

/** @description Datos requeridos para invitar a un torneo */
export type TournamentInviteFormData = {
  idTDA: number;
  /** @description ID del torneo */
  idGrupo: number;
  /** @description ID de la miniliga */
  idMiniLiga: number;

  /** @description Nombres de los usuarios invitados */
  names: string[];

  /** @description Emails de los usuarios invitados */
  emails: string[];
};

/** @description Datos requeridos para invitar a jugar */
export type PlayInviteFormData = {
  /** @description Nombre del usuario invitado */
  name: string;

  /** @description Email del usuario invitado */
  email: string;
};

export interface InviteUserByIdResponse {
  estado: boolean;
  mensaje?: string;
  codError?: number;
  error?: {
    code: number;
    msg: string;
  };
  invPendiente?: boolean;
  idUsuarioDT?: number;
}
export interface SearchDtsResponse {
  results: {
    id: number;
    name: string;
    lastName: string;
    teamName: string;
    location: string;
  }[];
  total: number;
}

export interface UsuarioDTReducidoTO {
  idUsuario: number;
  nombres: string;
  apellido: string;
  club: string;
  provincia: string;
  nombreEquipo: string;
  edad: number;
  idEstado?: number;
  nombreEstado?: string;
  camiseta: string;
  localidad: string;
  fotoPerfil: string;
  id: number;
}

export interface ResponseSugerirUsuariosGCA {
  estado: boolean;
  mensaje?: string;
  codError?: number;
  usuariosSugeridos: UsuarioDTReducidoTO[];
}

export type FormData = {
  name: string;
  email: string;
};

/**
 * Form data for inviting friends to Copa de Amigos
 */
export interface CopaAmigosInviteFormData {
  idGrupo: number;
  names?: string[];
  emails?: string[];
}

/**
 * Response from inviting friends to Copa de Amigos
 */
export interface ResponseInvitarAmigoGCA {
  status: string;
  message: string;
  success: boolean;
}

/**
 * Item in the Copa de Amigos ranking
 */
export interface ItemRankingGrupoCopaAmigosTO {
  id: number;
  nombreGrupo: string;
  puesto: number;
  puntos: number;
  descalificado: boolean;
}

/**
 * Response for the top 10 ranking in Copa de Amigos
 */
export type ResponseCopaDeAmigosTop10 = ItemRankingGrupoCopaAmigosTO[];

/**
 * ResponseOpInfo PostLogin Miniligas
 */
interface ResponseOpInfo {
  codop: string;
  idTA?: number;
  idGCA?: number;
  idML?: number;
  invitacionTdA: boolean;
  invitacionML: boolean;
  invitacionGCA: boolean;
}

/**
 * Response PostLogin Miniligas
 */
interface ResponsePostLogin {
  opInfo: ResponseOpInfo;
  idParamInvitacion: number;
  nombreTA?: string;
  nombreCopaAmigos?: string;
  nombreML?: string;
  tkRed: string;
  noEsOpUs: boolean;
}

/**
 * ResponseAccionPostLogin Miniligas
 */
export interface ResponseAccionPostLogin {
  estado: boolean;
  mensaje: string;
  codError: number;
  postLogin: ResponsePostLogin;
}

export enum InvitationType {
  TORNEO = 'torneo',
  COPA = 'copa',
  MINILIGA = 'miniliga',
}
